export default function PHP_decoct() {
  return (
    <div>
      <h1>PHP_decoct</h1>
    </div>
  );
}
